<app-tables
  [tableHeader]="tableHeader"
  [footerText]="footerText"
  [data]="consultationList"
  [totalCount]="consultationCount"
  [columns]="columns"
  [filters]="filters"
  (filtersChange)="filterConsultationList($event.filters, $event.sort)"
  (onPageChange)="onPageChange($event)"
  (onPageSizeChange)="onPageSizeChange($event)"
  [tableLoading]="consultationListLoading"
  [totalPage]="totalPage"
  [pageSize]="pageSize"
  [columnWidths]="columnWidths"
  (handleGetConsultationList)="getConsultationList(1, pageSize, filters)"
></app-tables>
